"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RADIAN = Math.PI / 180;
var toRadian = function (degree) {
    return RADIAN * degree;
};
exports.default = toRadian;
//# sourceMappingURL=to-radian.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/to-radian.js
// module id = 1155
// module chunks = 37